import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CSSTransition } from 'react-transition-group'
import SendGTAGEvent from "../../utils/sendGTAGEvent";

import HeaderFilter from "../HeaderFilter";
import FooterFilter from "../FooterFilter";

import { ReactComponent as ArrowDown } from '../../assets/arrow-down.svg'
import { ReactComponent as ArrowUp } from '../../assets/arrow-up.svg'
import { onDisabledScrollHandler, onEnableScrollHandler, windowScreenWidth } from "../../utils/ScrollHandler";

import * as S from "./styles";
import FilterCategoryItem from "../FilterCategoryItem";

interface IFilterState {
    search: string;
    category: string;
    brands: string;
}

interface IFilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onClearPage: () => void;
    filterConfigs: {
        shouldHide: boolean;
        filterName: string;
        filterTitle: string;
        filterType: 'radio' | any;
        filterCategoryItems?: {
            filterItemName: string;
            filterItemValue: string | number[];
            id: number;
            brands?: {
                filterItemName: string;
                filterItemValue: string;
            }[]
        }[];
        isOpen: boolean;
    }[]
    setFilter: Dispatch<SetStateAction<IFilterState>>;
    onChangeFilterStatesHandler: (filterKey: string) => void;
    onClearFilter: () => void;
    className: string;
}

const FilterCategoryModal: React.FC<IFilterModalProps> = ({
    filterConfigs,
    onClearPage,
    isOpen,
    onClose,
    setFilter,
    onChangeFilterStatesHandler,
    onClearFilter,
    className,
}) => {
    const [filterProperties, setfilterProperties] = useState<IFilterState | any>({})
    const [deviceViewport, setDeviceViewport] = useState(false)

    const nodeRef = useRef(null)

    const onClickModalHandler = useCallback(() => {
        onClearPage()
        setFilter(() => ({ ...filterProperties }))
        onClose()
        SendGTAGEvent(
            'seleciona_categoria',
            'Categoria',
            'Clicou em botão "Ver resultado"',
            `${JSON.stringify(filterProperties)}`
        )
    }, [onClearPage, setFilter, onClose, filterProperties])

    const onClearFilterProperties = useCallback(() => {
        setfilterProperties(() => ({ search: 'todos' }))
    }, [])

    const onClearAllHandler = useCallback(() => {
        onClearFilter();
        onClearFilterProperties()
        SendGTAGEvent(
            'limpa_categoria',
            'Categoria',
            'Clicou em botão "Limpar Filtros"')
        return setFilter((prevState) => ({ ...prevState, search: 'todos' }))
    }, [onClearFilterProperties, onClearFilter, setFilter])

    const filterContentJsx = useMemo(() => (
        <S.FilterOptions>
            {
                filterConfigs.map((filterConfig) => (

                    <S.Contente key={filterConfig.filterName} hidden={filterConfig.shouldHide}>

                        {deviceViewport ?
                            <S.ButtonTitle onClick={() => deviceViewport ? onChangeFilterStatesHandler(filterConfig.filterName) : {}}>
                                <label>{filterConfig.filterTitle}</label>
                                {filterConfig.isOpen && deviceViewport ? <ArrowUp /> : <ArrowDown />}
                            </S.ButtonTitle>
                            :
                            <label>{filterConfig.filterTitle}</label>
                        }

                        <FilterCategoryItem
                            filterProperties={filterProperties}
                            isOpen={filterConfig.isOpen}
                            filterName={filterConfig.filterName}
                            setfilterProperties={setfilterProperties}
                            filterType={filterConfig.filterType}
                            filterCategoryItems={filterConfig.filterCategoryItems}
                            onClose={onClose}
                        />
                    </S.Contente>
                ))
            }

        </S.FilterOptions>
    ), [deviceViewport, filterConfigs, filterProperties, onChangeFilterStatesHandler, onClose])

    useEffect(() => {
        if (isOpen) {
            onDisabledScrollHandler()
            if (windowScreenWidth()) { setDeviceViewport(true) }
        } else {
            onEnableScrollHandler()
        }
    }, [isOpen])

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={400} classNames="top_bottom_effect" unmountOnExit>
            <S.Container className={className} isOpen={isOpen}>

                <HeaderFilter onClose={onClose} />
                {filterContentJsx}
                <FooterFilter onClickReset={onClearAllHandler} onClickApply={onClickModalHandler} isOpen={isOpen} />

            </S.Container>
        </CSSTransition>
    )
};

export default FilterCategoryModal;
